import React from "react"

export function Footer() {

    return (
        <footer>
            © 2026 Kateryna Kirkwood.
        </footer>
    )
}